import { render, staticRenderFns } from "./attachmentGalleryOverview.vue?vue&type=template&id=253aec1b&scoped=true"
import script from "./attachmentGalleryOverview.vue?vue&type=script&lang=js"
export * from "./attachmentGalleryOverview.vue?vue&type=script&lang=js"
import style0 from "./attachmentGalleryOverview.vue?vue&type=style&index=0&id=253aec1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253aec1b",
  null
  
)

export default component.exports